// extracted by mini-css-extract-plugin
module.exports = {"mark7":"Maps_mark7__1KZ39","mapsTitle":"Maps_mapsTitle__1BqBk","pinMaps":"Maps_pinMaps__Bcu2X"};